<template>
  <div>
    <el-dialog
      :title="this.value.isCreate ? '上传新图片' : '修改图片'"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
    >
      <div style="text-align: center">
        <el-upload drag :action="uploadUrl" :on-success="onUploadSucceeded" :before-upload="beforeUpload">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">点击（或者将图片文件拖到此处）开始上传</div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
export default {
  data() {
    return {
      uploadUrl: `${util.getBackendApiBase()}/v1/admin/uploadPicture`,
      visible: true,
      form: {
        uidList: "",
        module: 1,
      },
      rules: {
        uidList: [{ required: true, message: " ", trigger: "blur" }],
      },
    };
  },

  props: {
    value: Object,
  },

  created() {
    if (!this.value.isCreate) {
      this.form.uidList = this.value.oldData.uidList;
    }
  },

  methods: {
    /**
     * 上传之前的回调
     * @param {*} file 
     */
      beforeUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';

        if (!isJPG && !isPNG) {
          this.$message.error("仅允许上传JPG或者PNG格式文件");
          return false;
        }

        return true;
      },

    /**
     * 上传成功
     */
    onUploadSucceeded(response, file, fileList) {
      this.$message({
        message: "上传成功",
        type: "success"
      });

      // 关闭当前对话框
      this.visible = false;
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>